import { isDesktop } from '../platform/bridge.js';
import { useUiStore } from '../store/ui.js';

/**
 * "업무 PC 한 켠에 켜놓기"를 위한 창 설정.
 *
 * 데스크톱에서만 나타난다. 웹에서 이 토글들을 보여주면 눌러도 아무 일이
 * 없어서 고장난 것처럼 보인다.
 */
export function DesktopControls() {
  const alwaysOnTop = useUiStore((s) => s.alwaysOnTop);
  const miniMode = useUiStore((s) => s.miniMode);
  const autoStart = useUiStore((s) => s.autoStart);
  const setAlwaysOnTop = useUiStore((s) => s.setAlwaysOnTop);
  const setMiniMode = useUiStore((s) => s.setMiniMode);
  const setAutoStart = useUiStore((s) => s.setAutoStart);

  if (!isDesktop) return null;

  return (
    <div className="flex items-center gap-1">
      <Toggle
        on={miniMode}
        onChange={setMiniMode}
        label="미니"
        title="폭 320px 세로 창으로. 모니터 가장자리에 세워두는 용도"
      />
      <Toggle
        on={alwaysOnTop}
        onChange={setAlwaysOnTop}
        label="항상 위"
        title="다른 창 위에 계속 띄워 둡니다"
      />
      <Toggle
        on={autoStart}
        onChange={setAutoStart}
        label="자동 시작"
        title="로그인하면 트레이로 조용히 시작합니다"
      />
    </div>
  );
}

function Toggle({
  on,
  onChange,
  label,
  title,
}: {
  on: boolean;
  onChange: (on: boolean) => void;
  label: string;
  title: string;
}) {
  return (
    <button
      type="button"
      onClick={() => onChange(!on)}
      aria-pressed={on}
      title={title}
      className={`rounded px-2 py-1 text-xs ${
        on ? 'bg-neutral-700 text-neutral-100' : 'text-neutral-500 hover:bg-neutral-800'
      }`}
    >
      {label}
    </button>
  );
}
